<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item url="/admin/dashboard" :class="getRoute() === 'Dashboard' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Dashboard'">
          <template v-slot:icon>
            <i class="ni ni-tv-2 aqua text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item url="/admin/colaboradores" :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '' : 'Colaboradores'">
          <template v-slot:icon>
            <i class="bi bi-people-fill aqua text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item url="/admin/pontuacao" :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '' : 'Pontuação'">
          <template v-slot:icon>
            <i class="bi bi-bar-chart-line-fill aqua text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item url="/admin/tarefas" :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '' : 'Tarefas'">
          <template v-slot:icon>
            <i class="bi bi-ui-checks aqua text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item url="/admin/horarios" :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '' : 'Definir Horários '">
          <template v-slot:icon>
            <i class="bi bi-clock-fill aqua text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item url="/admin/usuarios" :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '' : 'Usuários'">
          <template v-slot:icon>
            <i class="ni ni-single-02 aqua text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item url="/admin/acesso-bling" :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '' : 'Acesso Bling'">
          <template v-slot:icon>
            <i class="ni ni-settings aqua text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>
  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card :class="cardBg" textPrimary="Need Help?" textSecondary="Please check our docs" />
  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
import SidenavCard from "./SidenavCard.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
    };
  },
  components: {
    SidenavItem,
    SidenavCard,
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
  },
};
</script>
<style scoped>
.navbar-vertical.bg-white .navbar-nav>.nav-item .nav-link.active {
  background-color: #56008f;
  color: #fff;
}

.navbar-vertical.bg-white .navbar-nav>.nav-item .nav-link.active i {
  color: #fff;
}

span.nav-link {
  color: #56008f;
  font-weight: 600;
}

.aqua {
  color: #56008f;
}

.aqua {
  color: #56008f;
}
</style>
